module.exports = __webpack_public_path__ + "img/0Q3A7268_L_Black_MockedUp.7cb02a6a.jpg";